import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { SignupFormTemplate } from "@/components/signup/SignupFormTemplate.tsx";
import { FormInput } from "@/components/custom/form/FormInput.tsx";
import { signupFormSchemaOne } from "@/schemas/signupFormSchema.ts";

interface SignupFirstSectionProps {
    onSubmit: (data: {
        username: string;
        email: string;
        password: string;
    }) => void;
}

export function SignupFormOne(props: SignupFirstSectionProps) {
    const form = useForm<z.infer<typeof signupFormSchemaOne>>({
        resolver: zodResolver(signupFormSchemaOne),
        defaultValues: {
            username: "",
            email: "",
            password: "",
        },
    });

    async function onSubmit(data: z.infer<typeof signupFormSchemaOne>) {
        props.onSubmit(data);
    }

    return (
        <SignupFormTemplate form={form} onSubmit={onSubmit}>
            <FormInput form={form} name="username" label="Username" required />
            <FormInput
                form={form}
                name="email"
                label="E-Mail"
                required
                autocomplete="email username"
            />
            <FormInput
                form={form}
                name="password"
                label="Password"
                type="password"
                autocomplete="new-password"
                required
            />
        </SignupFormTemplate>
    );
}
